(function () {
  'use strict';

  var STORAGE_PREFIX = 'bz-dream-board:v2:';
  var SPICE_NAMES = {
    1: 'Kid-safe',
    2: 'Beginner',
    3: 'Intermediate',
    4: 'Advanced',
    5: 'Extreme'
  };
  var LEGACY_GUIDE_IDS = {
    'black deathstalker': 'leiurus-quinquestriatus-deathstalker-scorpion',
    'black deathstalker scorpion': 'leiurus-quinquestriatus-deathstalker-scorpion',
    'black deathstalker scorpion 1': 'leiurus-quinquestriatus-deathstalker-scorpion',
    'sunset ghost millipede female': 'alienostreptus-bicoloripes-ghost-rider-millipede',
    'female brazilian white knee': 'acanthoscurria-geniculata-brazilian-white-knee-tarantula',
    'green lynx spider peucetia viridans': 'peucetia-viridans-green-lynx-spider',
    'chinese swimming scorpion': 'chinese-swimming-scorpion-lychas-mucronatus',
    'chinese swimming scorpion lychas mucronatus': 'chinese-swimming-scorpion-lychas-mucronatus'
  };

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function storageGet(key, fallback) {
    try {
      var raw = window.localStorage.getItem(STORAGE_PREFIX + key);
      return raw === null ? fallback : JSON.parse(raw);
    } catch (_) {
      return fallback;
    }
  }

  function storageSet(key, value) {
    try {
      window.localStorage.setItem(STORAGE_PREFIX + key, JSON.stringify(value));
    } catch (_) {
      // Private browsing and strict storage policies should not break the board.
    }
  }

  function sessionGet(key, fallback) {
    try {
      var raw = window.sessionStorage.getItem(STORAGE_PREFIX + key);
      return raw === null ? fallback : JSON.parse(raw);
    } catch (_) {
      return fallback;
    }
  }

  function sessionSet(key, value) {
    try {
      window.sessionStorage.setItem(STORAGE_PREFIX + key, JSON.stringify(value));
    } catch (_) {
      // A pending marker is only a convenience; the Shopify post still works without it.
    }
  }

  function sessionRemove(key) {
    try {
      window.sessionStorage.removeItem(STORAGE_PREFIX + key);
    } catch (_) {
      // Ignore storage restrictions.
    }
  }

  function normalize(value) {
    var text = String(value || '').toLowerCase().trim();
    if (text.normalize) {
      text = text.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
    }
    return text
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function slugify(value) {
    return normalize(value).replace(/\s+/g, '-') || 'request';
  }

  function safeInteger(value, fallback) {
    var parsed = parseInt(value, 10);
    return isFinite(parsed) ? parsed : fallback;
  }

  function htmlToText(element) {
    if (!element) return '';
    var html = element.innerHTML || '';
    html = html
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/(?:p|div|li)>/gi, '\n')
      .replace(/<[^>]*>/g, '');
    var decoder = document.createElement('textarea');
    decoder.innerHTML = html;
    return decoder.value.replace(/\r/g, '').replace(/\n{3,}/g, '\n\n').trim();
  }

  function htmlStringToText(html) {
    var container = document.createElement('div');
    container.innerHTML = String(html || '');
    return htmlToText(container);
  }

  function parseLabels(text) {
    var labels = {};
    String(text || '').split(/\n/).forEach(function (line) {
      var match = line.match(/^\s*([A-Za-z][A-Za-z ]{0,38}):\s*(.*?)\s*$/);
      if (match) labels[match[1].toLowerCase()] = match[2];
    });
    return labels;
  }

  function aliasList(value) {
    if (Array.isArray(value)) {
      return value.reduce(function (all, item) {
        return all.concat(aliasList(item));
      }, []);
    }
    return String(value || '')
      .split(/[\n,;|]+/)
      .map(function (item) { return item.trim(); })
      .filter(Boolean);
  }

  function readIndex(root) {
    var script = root.querySelector('[data-bz-wishlist-index]');
    var index = [];
    if (script) {
      try {
        index = JSON.parse(script.textContent || '[]');
      } catch (error) {
        console.warn('[Dream Board] Could not read the care-guide index.', error);
      }
    }

    return index
      .filter(function (item) { return item && item.name; })
      .map(function (item) {
        var aliases = aliasList(item.aliases);
        var prepared = {
          id: String(item.id || slugify(item.name)),
          name: String(item.name || '').trim(),
          sci: String(item.sci || '').trim(),
          spice: Math.max(0, Math.min(5, safeInteger(item.spice, 0))),
          aliases: aliases
        };
        prepared.nameNorm = normalize(prepared.name);
        prepared.sciNorm = normalize(prepared.sci);
        prepared.aliasNorms = aliases.map(normalize).filter(Boolean);
        prepared.searchNorm = normalize([prepared.name, prepared.sci].concat(aliases).join(' '));
        return prepared;
      });
  }

  function setUnique(map, key, value) {
    if (!key) return;
    if (!Object.prototype.hasOwnProperty.call(map, key)) {
      map[key] = value;
    } else if (map[key] && map[key].id !== value.id) {
      map[key] = null;
    }
  }

  function buildIndexMaps(index) {
    var maps = { byId: {}, byName: {}, bySci: {}, byAlias: {} };
    index.forEach(function (guide) {
      maps.byId[guide.id] = guide;
      setUnique(maps.byName, guide.nameNorm, guide);
      setUnique(maps.bySci, guide.sciNorm, guide);
      guide.aliasNorms.forEach(function (alias) {
        setUnique(maps.byAlias, alias, guide);
      });
    });
    return maps;
  }

  function exactGuide(maps, name, sci, handle) {
    if (handle && maps.byId[handle]) return maps.byId[handle];
    var legacyHandle = LEGACY_GUIDE_IDS[normalize(name)];
    if (legacyHandle && maps.byId[legacyHandle]) return maps.byId[legacyHandle];
    var nameNorm = normalize(name);
    var sciNorm = normalize(sci);
    return maps.bySci[sciNorm] ||
      maps.bySci[nameNorm] ||
      maps.byName[nameNorm] ||
      maps.byName[sciNorm] ||
      maps.byAlias[nameNorm] ||
      maps.byAlias[sciNorm] ||
      null;
  }

  function eventKey(name, guide, suppliedKey) {
    if (guide) return 'care-guide:' + guide.id;
    if (suppliedKey) return String(suppliedKey).trim();
    return 'typed:' + normalize(name);
  }

  function isComplete(status) {
    var key = normalize(status);
    return key === 'complete' || key === 'completed';
  }

  function readEvents(root, maps, commentRecords) {
    var source = root.querySelector('[data-bz-board-source]');
    var currentMonth = root.getAttribute('data-bz-current-month') || '';
    var completed = {};
    var events = [];
    if (!source) return events;

    Array.prototype.slice.call(source.querySelectorAll('[data-bz-seed-event]')).forEach(function (node) {
      var name = node.getAttribute('data-name') || 'Wishlist request';
      var sci = node.getAttribute('data-sci') || '';
      var guide = exactGuide(maps, name, sci, '');
      var key = eventKey(name, guide, '');
      if (isComplete(node.getAttribute('data-status'))) completed[key] = true;
    });

    Array.prototype.slice.call(source.querySelectorAll('[data-bz-seed-event]')).forEach(function (node) {
      var name = node.getAttribute('data-name') || 'Wishlist request';
      var sci = node.getAttribute('data-sci') || '';
      var guide = exactGuide(maps, name, sci, '');
      var key = eventKey(name, guide, '');
      events.push({
        id: node.getAttribute('data-event-id') || key,
        voter: node.getAttribute('data-event-id') || key,
        key: key,
        name: guide ? guide.name : name,
        sci: guide ? guide.sci : sci,
        spice: guide ? guide.spice : 0,
        guide: guide,
        createdAt: '',
        monthly: false,
        manualComplete: !!completed[key]
      });
    });

    function addComment(record) {
      var labels = parseLabels(record.bodyText);
      var name = labels['request name'] || labels['species name'] || '';
      if (!name) return;
      var sci = labels['scientific name'] || '';
      var handle = labels['guide handle'] || '';
      var guide = exactGuide(maps, name, sci, handle);
      var key = eventKey(name, guide, labels['request key'] || '');
      events.push({
        id: record.id || key,
        voter: record.voter || '',
        key: key,
        name: guide ? guide.name : name,
        sci: guide ? guide.sci : sci,
        spice: guide ? guide.spice : Math.max(0, Math.min(5, safeInteger(labels.spice, 0))),
        guide: guide,
        createdAt: record.createdMonth || '',
        monthly: record.createdMonth === currentMonth,
        manualComplete: !!completed[key]
      });
    }

    if (Array.isArray(commentRecords)) {
      commentRecords.forEach(function (record) {
        addComment({
          id: 'comment:' + String(record.id || ''),
          voter: record.voterKey || '',
          createdMonth: record.createdMonth || '',
          bodyText: htmlStringToText(record.bodyHtml)
        });
      });
    } else {
      Array.prototype.slice.call(source.querySelectorAll('[data-bz-comment-event]')).forEach(function (node) {
        addComment({
          id: node.getAttribute('data-event-id') || '',
          voter: node.getAttribute('data-voter-key') || '',
          createdMonth: node.getAttribute('data-created-month') || '',
          bodyText: htmlToText(node.querySelector('[data-bz-comment-body]'))
        });
      });
    }

    return events;
  }

  function fetchCommentPage(root, page) {
    var commentsUrl = root.getAttribute('data-bz-comments-url');
    var articleId = root.getAttribute('data-bz-article-id') || '';
    if (!commentsUrl) return Promise.reject(new Error('The comment endpoint is unavailable.'));
    var url = new URL(commentsUrl, window.location.origin);
    var currentParams = new URLSearchParams(window.location.search);
    url.searchParams.set('view', 'dream-board-comments');
    url.searchParams.set('page', String(page));
    if (currentParams.get('preview_theme_id')) {
      url.searchParams.set('preview_theme_id', currentParams.get('preview_theme_id'));
    }
    if (currentParams.get('pb')) url.searchParams.set('pb', currentParams.get('pb'));

    return window.fetch(url.toString(), {
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) throw new Error('Comment page returned ' + response.status + '.');
      return response.text();
    }).then(function (text) {
      var result = JSON.parse(text);
      if (
        !result ||
        result.schema !== 1 ||
        String(result.articleId || '') !== articleId ||
        safeInteger(result.page, 0) !== page ||
        !Array.isArray(result.comments)
      ) {
        throw new Error('The comment endpoint returned an unexpected payload.');
      }
      return result;
    });
  }

  function fetchCommentPages(root, firstPage, lastPage, batchSize) {
    var results = [];

    function nextBatch(start) {
      if (start > lastPage) return Promise.resolve(results);
      var requests = [];
      var end = Math.min(lastPage, start + batchSize - 1);
      for (var page = start; page <= end; page += 1) {
        requests.push(fetchCommentPage(root, page));
      }
      return Promise.all(requests).then(function (batch) {
        results = results.concat(batch);
        return nextBatch(end + 1);
      });
    }

    return nextBatch(firstPage);
  }

  function loadAllComments(root, retrying) {
    var source = root.querySelector('[data-bz-board-source]');
    var total = safeInteger(root.getAttribute('data-bz-comment-count'), 0);
    var rendered = source ? source.querySelectorAll('[data-bz-comment-event]').length : 0;
    if (!total) return Promise.resolve(null);

    return fetchCommentPage(root, 1).then(function (firstPage) {
      var pages = Math.max(1, safeInteger(firstPage.pages, 1));
      var expected = Math.max(0, safeInteger(firstPage.total, total));
      return fetchCommentPages(root, 2, pages, retrying ? 1 : 4).then(function (remainingPages) {
        var records = firstPage.comments.slice();
        remainingPages.forEach(function (result) {
          if (Array.isArray(result.comments)) records = records.concat(result.comments);
        });
        var byId = {};
        records.forEach(function (record) {
          if (record && record.id) byId[String(record.id)] = record;
        });
        var unique = Object.keys(byId).map(function (id) { return byId[id]; });
        if (unique.length !== expected && !retrying) return loadAllComments(root, true);
        if (unique.length !== expected) {
          throw new Error('The complete comment ledger changed while it was loading.');
        }
        return unique;
      });
    }).catch(function (error) {
      if (total > rendered) {
        var warning = root.querySelector('[data-bz-ledger-warning]');
        if (warning) warning.hidden = false;
      }
      throw error;
    });
  }

  function fetchStockPage(root, page) {
    var stockUrl = root.getAttribute('data-bz-stock-url');
    var stockHandle = root.getAttribute('data-bz-stock-handle') || '';
    if (!stockUrl) return Promise.reject(new Error('The stock endpoint is unavailable.'));
    var url = new URL(stockUrl, window.location.origin);
    var currentParams = new URLSearchParams(window.location.search);
    url.searchParams.set('view', 'dream-board-stock');
    url.searchParams.set('page', String(page));
    if (currentParams.get('preview_theme_id')) {
      url.searchParams.set('preview_theme_id', currentParams.get('preview_theme_id'));
    }
    if (currentParams.get('pb')) url.searchParams.set('pb', currentParams.get('pb'));

    return window.fetch(url.toString(), {
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) throw new Error('Stock page returned ' + response.status + '.');
      return response.text();
    }).then(function (text) {
      var result = JSON.parse(text);
      if (
        !result ||
        result.schema !== 1 ||
        String(result.collectionHandle || '') !== stockHandle ||
        safeInteger(result.page, 0) !== page ||
        !Array.isArray(result.products)
      ) {
        throw new Error('The stock endpoint returned an unexpected payload.');
      }
      return result;
    });
  }

  function fetchStockPages(root, firstPage, lastPage, batchSize) {
    var results = [];

    function nextBatch(start) {
      if (start > lastPage) return Promise.resolve(results);
      var requests = [];
      var end = Math.min(lastPage, start + batchSize - 1);
      for (var page = start; page <= end; page += 1) {
        requests.push(fetchStockPage(root, page));
      }
      return Promise.all(requests).then(function (batch) {
        results = results.concat(batch);
        return nextBatch(end + 1);
      });
    }

    return nextBatch(firstPage);
  }

  function loadStockProducts(root, retrying) {
    return fetchStockPage(root, 1).then(function (firstPage) {
      var pages = Math.max(1, safeInteger(firstPage.pages, 1));
      var expected = Math.max(0, safeInteger(firstPage.total, firstPage.products.length));
      return fetchStockPages(root, 2, pages, retrying ? 1 : 4).then(function (remainingPages) {
        var records = firstPage.products.slice();
        remainingPages.forEach(function (result) {
          if (Array.isArray(result.products)) records = records.concat(result.products);
        });
        var byId = {};
        records.forEach(function (record) {
          if (record && record.id) byId[String(record.id)] = record;
        });
        var unique = Object.keys(byId).map(function (id) { return byId[id]; });
        if (unique.length !== expected && !retrying) return loadStockProducts(root, true);
        if (unique.length !== expected) {
          throw new Error('The complete stock catalog changed while it was loading.');
        }
        return unique;
      });
    });
  }

  function productChoiceScore(item, product) {
    var titleNorm = normalize(product.title);
    var score = 100;
    if (item.sci && normalize(item.sci).length > 5 && titleNorm.indexOf(normalize(item.sci)) >= 0) score += 40;
    if (item.name && normalize(item.name).length > 5 && titleNorm.indexOf(normalize(item.name)) >= 0) score += 25;
    if (/\b(?:count lot|sexed pair|wholesale|bulk)\b/.test(titleNorm)) score -= 20;
    score -= Math.min(10, titleNorm.length / 20);
    return score;
  }

  function chooseProduct(item, products) {
    return products.slice().sort(function (a, b) {
      var scoreDifference = productChoiceScore(item, b) - productChoiceScore(item, a);
      if (scoreDifference) return scoreDifference;
      var dateDifference = String(b.publishedAt || '').localeCompare(String(a.publishedAt || ''));
      if (dateDifference) return dateDifference;
      return String(a.title || '').localeCompare(String(b.title || ''));
    })[0] || null;
  }

  function classifyItems(items, products) {
    var availableByGuide = {};
    (products || []).forEach(function (product) {
      if (!product || !product.inStock || !product.guideId) return;
      if (!availableByGuide[product.guideId]) availableByGuide[product.guideId] = [];
      availableByGuide[product.guideId].push(product);
    });

    var open = [];
    var completed = [];
    items.forEach(function (item) {
      var matches = item.guide ? (availableByGuide[item.guide.id] || []) : [];
      item.product = matches.length ? chooseProduct(item, matches) : null;
      item.availableListings = matches.length;
      item.isComplete = !!item.manualComplete || !!item.product;
      item.completionType = item.product ? 'stock' : (item.manualComplete ? 'manual' : '');
      if (item.isComplete) {
        completed.push(item);
      } else {
        open.push(item);
      }
    });

    completed.sort(function (a, b) {
      var stockDifference = (b.product ? 1 : 0) - (a.product ? 1 : 0);
      if (stockDifference) return stockDifference;
      var voteDifference = b.votes - a.votes;
      if (voteDifference) return voteDifference;
      return a.name.localeCompare(b.name);
    });

    return { open: open, completed: completed };
  }

  function aggregateEvents(events) {
    var byKey = {};
    events.forEach(function (event) {
      if (!event.key || !event.name) return;
      var item = byKey[event.key];
      if (!item) {
        item = byKey[event.key] = {
          key: event.key,
          name: event.name,
          sci: event.sci || '',
          spice: event.spice || 0,
          guide: event.guide || null,
          votes: 0,
          monthVotes: 0,
          manualComplete: !!event.manualComplete,
          voters: Object.create(null)
        };
      }
      if (event.manualComplete) item.manualComplete = true;
      var voterKey = normalize(event.voter) || event.id;
      if (Object.prototype.hasOwnProperty.call(item.voters, voterKey)) return;
      item.voters[voterKey] = true;
      item.votes += 1;
      if (event.monthly) item.monthVotes += 1;
      if (!item.guide && event.guide) {
        item.guide = event.guide;
        item.name = event.guide.name;
        item.sci = event.guide.sci;
        item.spice = event.guide.spice;
      }
    });

    return Object.keys(byKey).map(function (key) { return byKey[key]; });
  }

  function sortItems(items, voteField) {
    return items.slice().sort(function (a, b) {
      var difference = b[voteField] - a[voteField];
      if (difference) return difference;
      difference = b.votes - a.votes;
      if (difference) return difference;
      return a.name.localeCompare(b.name);
    });
  }

  function spiceDot(item) {
    var dot = document.createElement('span');
    dot.className = 'bz-wishlist-spice' + (item.spice ? '' : ' bz-wishlist-spice--pending');
    if (item.spice) {
      dot.setAttribute('data-spice', String(item.spice));
      dot.title = 'Spice ' + item.spice + ': ' + (SPICE_NAMES[item.spice] || '');
      dot.setAttribute('aria-label', dot.title);
    } else {
      dot.title = "Awaiting Big Z's tag";
      dot.setAttribute('aria-label', dot.title);
    }
    dot.setAttribute('role', 'img');
    return dot;
  }

  function speciesCopy(item, withTopline) {
    var species = document.createElement('span');
    species.className = 'bz-wishlist-species';
    var name = document.createElement('span');
    name.className = 'bz-wishlist-species__name';
    name.textContent = item.name;

    if (withTopline) {
      var topLine = document.createElement('span');
      topLine.className = 'bz-wishlist-species__topline';
      topLine.appendChild(name);
      topLine.appendChild(spiceDot(item));
      species.appendChild(topLine);
    } else {
      species.appendChild(name);
    }

    var sci = document.createElement('em');
    sci.className = 'bz-wishlist-species__sci';
    sci.textContent = item.sci || "As typed · awaiting Big Z's tag";
    species.appendChild(sci);
    return species;
  }

  function voteButton(item, wide, submitted) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'bz-wishlist-vote' + (wide ? ' bz-wishlist-vote--wide' : '');
    button.setAttribute('data-bz-vote', '');
    button.setAttribute('data-item-key', item.key);
    button.setAttribute('aria-pressed', submitted ? 'true' : 'false');
    button.setAttribute('aria-label', submitted ? 'Vote already sent for ' + item.name : 'Want ' + item.name + ' too');

    var label = document.createElement('span');
    label.setAttribute('data-bz-vote-label', '');
    label.textContent = submitted ? (wide ? 'VOTE SENT' : '✓') : (wide ? '+ WANT THIS TOO' : '+');
    button.appendChild(label);
    return button;
  }

  function renderTop(root, items, submitted) {
    var list = root.querySelector('[data-bz-top-list]');
    var count = root.querySelector('[data-bz-top-count]');
    var period = root.querySelector('[data-bz-top-period]');
    var empty = root.querySelector('[data-bz-top-empty]');
    if (!list) return;
    list.textContent = '';

    var monthly = items.filter(function (item) {
      return item.monthVotes > 0;
    });
    var useMonthly = monthly.length > 0;
    var voteField = useMonthly ? 'monthVotes' : 'votes';
    var top = sortItems(useMonthly ? monthly : items, voteField).slice(0, 5);

    if (count) count.textContent = String(top.length);
    if (period) period.textContent = useMonthly ? 'This month' : 'All-time open votes';
    if (empty) empty.hidden = top.length !== 0;

    top.forEach(function (item, index) {
      var row = document.createElement('li');
      row.className = 'bz-wishlist-top-row';
      row.setAttribute('data-bz-board-item', '');
      row.setAttribute('data-item-key', item.key);

      var rank = document.createElement('span');
      rank.className = 'bz-wishlist-rank';
      rank.textContent = String(index + 1).padStart(2, '0');
      row.appendChild(rank);
      row.appendChild(speciesCopy(item, true));

      var votes = document.createElement('span');
      votes.className = 'bz-wishlist-votes';
      var voteCount = item[voteField];
      var number = document.createElement('span');
      number.textContent = String(voteCount);
      votes.appendChild(number);
      votes.appendChild(document.createTextNode(voteCount === 1 ? ' keeper' : ' keepers'));
      row.appendChild(votes);
      row.appendChild(voteButton(item, true, !!submitted[item.key]));
      list.appendChild(row);
    });
  }

  function communityRow(item, submitted) {
    var row = document.createElement('article');
    row.className = 'bz-wishlist-community-row';
    row.setAttribute('data-bz-board-item', '');
    row.setAttribute('data-item-key', item.key);
    row.appendChild(spiceDot(item));
    row.appendChild(speciesCopy(item, false));

    var votes = document.createElement('span');
    votes.className = 'bz-wishlist-votes';
    votes.textContent = String(item.votes);
    row.appendChild(votes);
    row.appendChild(voteButton(item, false, !!submitted[item.key]));
    return row;
  }

  function renderCommunity(root, items, submitted) {
    var grid = root.querySelector('[data-bz-community-grid]');
    var extra = root.querySelector('[data-bz-community-extra]');
    var count = root.querySelector('[data-bz-community-count]');
    var moreCount = root.querySelector('[data-bz-more-count]');
    var spectrum = root.querySelector('[data-bz-expand-spectrum]');
    var empty = root.querySelector('[data-bz-community-empty]');
    if (!grid || !extra) return;

    var sorted = sortItems(items, 'votes');
    var visible = sorted.slice(0, 8);
    var rest = sorted.slice(8);
    grid.textContent = '';
    extra.textContent = '';

    visible.forEach(function (item) {
      grid.appendChild(communityRow(item, submitted));
    });
    rest.forEach(function (item) {
      extra.appendChild(communityRow(item, submitted));
    });

    if (count) count.textContent = String(sorted.length);
    if (moreCount) moreCount.textContent = String(rest.length);
    if (empty) empty.hidden = sorted.length !== 0;
    if (spectrum) {
      spectrum.hidden = rest.length === 0;
      spectrum.setAttribute('aria-expanded', 'false');
    }
    extra.hidden = true;
  }

  function completedRow(item) {
    var row = document.createElement('article');
    row.className = 'bz-wishlist-completed-row' + (item.product ? ' is-in-stock' : ' is-manual');
    row.setAttribute('data-bz-completed-item', '');
    row.setAttribute('data-item-key', item.key);

    var found = document.createElement('span');
    found.className = 'bz-wishlist-completed-row__mark';
    found.textContent = item.product ? '★' : '✓';
    found.setAttribute('aria-hidden', 'true');
    row.appendChild(found);
    row.appendChild(speciesCopy(item, true));

    var meta = document.createElement('span');
    meta.className = 'bz-wishlist-completed-row__meta';
    var status = document.createElement('strong');
    status.className = 'bz-wishlist-completed-row__status';
    status.textContent = item.product
      ? (item.availableListings === 1 ? 'IN STOCK NOW' : item.availableListings + ' LISTINGS IN STOCK')
      : 'REQUEST COMPLETED';
    meta.appendChild(status);
    var keepers = document.createElement('span');
    keepers.textContent = item.votes + (item.votes === 1 ? ' keeper asked' : ' keepers asked');
    meta.appendChild(keepers);
    row.appendChild(meta);

    if (item.product) {
      var shop = document.createElement('a');
      shop.className = 'bz-wishlist-completed-row__shop';
      shop.href = item.product.url;
      shop.textContent = 'SHOP FELLA →';
      shop.setAttribute('aria-label', 'Shop ' + item.product.title);
      row.appendChild(shop);
    } else {
      var done = document.createElement('span');
      done.className = 'bz-wishlist-completed-row__done';
      done.textContent = 'FOUND ✓';
      row.appendChild(done);
    }

    return row;
  }

  function renderCompleted(root, items) {
    var list = root.querySelector('[data-bz-completed-list]');
    var extra = root.querySelector('[data-bz-completed-extra]');
    var count = root.querySelector('[data-bz-completed-count]');
    var moreCount = root.querySelector('[data-bz-completed-more-count]');
    var more = root.querySelector('[data-bz-expand-completed]');
    var empty = root.querySelector('[data-bz-completed-empty]');
    if (!list || !extra) return;

    var visibleLimit = window.matchMedia('(max-width: 749px)').matches ? 3 : 4;
    var visible = items.slice(0, visibleLimit);
    var rest = items.slice(visibleLimit);
    list.textContent = '';
    extra.textContent = '';
    visible.forEach(function (item) { list.appendChild(completedRow(item)); });
    rest.forEach(function (item) { extra.appendChild(completedRow(item)); });

    if (count) count.textContent = String(items.length);
    if (moreCount) moreCount.textContent = String(rest.length);
    if (empty) empty.hidden = items.length !== 0;
    if (more) {
      more.hidden = rest.length === 0;
      more.setAttribute('aria-expanded', 'false');
    }
    extra.hidden = true;
  }

  function setupCollapses(root) {
    Array.prototype.slice.call(root.querySelectorAll('[data-bz-collapse-toggle]')).forEach(function (button) {
      var name = button.getAttribute('data-bz-collapse-toggle');
      var region = root.querySelector('[data-bz-collapse-region="' + name + '"]');
      if (!region) return;

      var saved = storageGet('collapse:' + name, null);
      var expanded = saved === null
        ? (name !== 'community' || !window.matchMedia('(max-width: 749px)').matches)
        : !!saved;

      function setExpanded(next, save) {
        expanded = !!next;
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        region.hidden = !expanded;
        if (save) storageSet('collapse:' + name, expanded);
      }

      button.addEventListener('click', function () {
        setExpanded(!expanded, true);
      });
      setExpanded(expanded, false);
    });
  }

  function setupSpectrum(root) {
    var button = root.querySelector('[data-bz-expand-spectrum]');
    var extra = root.querySelector('[data-bz-community-extra]');
    var label = root.querySelector('[data-bz-spectrum-label]');
    if (!button || !extra) return;

    button.addEventListener('click', function () {
      var expanded = button.getAttribute('aria-expanded') === 'true';
      expanded = !expanded;
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      extra.hidden = !expanded;
      if (label) label.textContent = expanded ? 'Show the short list ↑' : 'See the full spectrum →';
    });
  }

  function setupCompletedExpansion(root) {
    var button = root.querySelector('[data-bz-expand-completed]');
    var extra = root.querySelector('[data-bz-completed-extra]');
    var label = root.querySelector('[data-bz-completed-more-label]');
    if (!button || !extra) return;

    button.addEventListener('click', function () {
      var expanded = button.getAttribute('aria-expanded') === 'true';
      expanded = !expanded;
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      extra.hidden = !expanded;
      if (label) label.textContent = expanded ? 'Show the short list ↑' : 'Show every match →';
    });
  }

  function appendHighlighted(element, source, query) {
    var text = String(source || '');
    var needle = String(query || '').trim();
    var index = text.toLowerCase().indexOf(needle.toLowerCase());
    if (!needle || index < 0) {
      element.textContent = text;
      return;
    }

    element.appendChild(document.createTextNode(text.slice(0, index)));
    var mark = document.createElement('mark');
    mark.textContent = text.slice(index, index + needle.length);
    element.appendChild(mark);
    element.appendChild(document.createTextNode(text.slice(index + needle.length)));
  }

  function suggestionScore(guide, queryNorm) {
    if (guide.nameNorm.indexOf(queryNorm) === 0) return 0;
    if (guide.sciNorm.indexOf(queryNorm) === 0) return 1;
    if (guide.aliasNorms.some(function (alias) { return alias.indexOf(queryNorm) === 0; })) return 2;
    if (guide.nameNorm.indexOf(queryNorm) >= 0) return 3;
    if (guide.sciNorm.indexOf(queryNorm) >= 0) return 4;
    return 5;
  }

  function setupForm(root, index, maps, itemsByKey, submitted, retryDraft) {
    var form = root.querySelector('#bz-wishlist-form');
    if (!form) return;

    var input = form.querySelector('[data-bz-wishlist-input]');
    var search = input && input.closest('.bz-wishlist-search');
    var popup = form.querySelector('[data-bz-wishlist-suggestions]');
    var results = form.querySelector('[data-bz-wishlist-results]');
    var noResults = form.querySelector('[data-bz-wishlist-no-results]');
    var freehand = form.querySelector('[data-bz-wishlist-freehand]');
    var freehandLabel = form.querySelector('[data-bz-wishlist-freehand-label]');
    var nextButton = form.querySelector('[data-bz-wishlist-next]');
    var contact = form.querySelector('[data-bz-wishlist-contact]');
    var contactCopy = form.querySelector('[data-bz-wishlist-contact-copy]');
    var confirmButton = form.querySelector('[data-bz-wishlist-confirm]');
    var cancelButton = form.querySelector('[data-bz-wishlist-cancel]');
    var author = form.querySelector('[data-bz-wishlist-author]');
    var email = form.querySelector('[data-bz-wishlist-email]');
    var body = form.querySelector('[data-bz-wishlist-body]');
    var honeypot = form.querySelector('[data-bz-wishlist-honeypot]');
    var status = form.querySelector('[data-bz-wishlist-status]');
    var selected = null;
    var currentAction = 'request';
    var activeOption = -1;
    var currentMatches = [];

    if (!input || !popup || !results || !nextButton || !contact || !body) return;

    function setStatus(message) {
      if (status) status.textContent = message || '';
    }

    function openPopup() {
      if (!input.value.trim()) return;
      popup.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      if (search) search.classList.add('is-open');
    }

    function closePopup() {
      popup.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      if (search) search.classList.remove('is-open');
      activeOption = -1;
    }

    function typedItem(value) {
      var name = String(value || '').trim();
      return {
        id: '',
        key: 'typed:' + normalize(name),
        name: name,
        sci: '',
        spice: 0,
        guide: null
      };
    }

    function guideItem(guide) {
      return {
        id: guide.id,
        key: 'care-guide:' + guide.id,
        name: guide.name,
        sci: guide.sci,
        spice: guide.spice,
        guide: guide
      };
    }

    function choose(item) {
      selected = item;
      input.value = item.name;
      closePopup();
      contact.hidden = true;
      setStatus(item.guide ? 'Spice ' + item.spice + ' comes from the care-guide index.' : "Big Z will verify this fella's tag.");
      nextButton.focus();
    }

    function makeSuggestion(guide, query, indexNumber) {
      var option = document.createElement('button');
      option.type = 'button';
      option.className = 'bz-wishlist-suggestion';
      option.id = input.id + '-option-' + indexNumber + '-' + guide.id;
      option.setAttribute('role', 'option');
      option.setAttribute('aria-selected', 'false');
      option.tabIndex = -1;

      option.appendChild(spiceDot(guide));
      var copy = document.createElement('span');
      copy.className = 'bz-wishlist-suggestion__copy';
      var name = document.createElement('span');
      name.className = 'bz-wishlist-suggestion__name';
      appendHighlighted(name, guide.name, query);
      var sci = document.createElement('em');
      sci.className = 'bz-wishlist-suggestion__sci';
      appendHighlighted(sci, guide.sci, query);
      copy.appendChild(name);
      copy.appendChild(sci);
      option.appendChild(copy);

      var tier = document.createElement('span');
      tier.className = 'bz-wishlist-suggestion__tier';
      tier.textContent = guide.spice ? 'Spice ' + guide.spice : 'Not rated';
      option.appendChild(tier);
      option.addEventListener('click', function () { choose(guideItem(guide)); });
      return option;
    }

    function setActiveOption(next) {
      var options = Array.prototype.slice.call(results.querySelectorAll('[role="option"]'));
      if (!options.length) return;
      activeOption = (next + options.length) % options.length;
      options.forEach(function (option, indexNumber) {
        var active = indexNumber === activeOption;
        option.classList.toggle('is-active', active);
        option.setAttribute('aria-selected', active ? 'true' : 'false');
        if (active) {
          input.setAttribute('aria-activedescendant', option.id);
          option.scrollIntoView({ block: 'nearest' });
        }
      });
    }

    function renderSuggestions() {
      var query = input.value.trim();
      var queryNorm = normalize(query);
      input.removeAttribute('aria-activedescendant');
      results.textContent = '';
      if (noResults) noResults.hidden = true;
      currentMatches = [];
      activeOption = -1;
      if (!queryNorm) {
        closePopup();
        return;
      }

      currentMatches = index
        .filter(function (guide) { return guide.searchNorm.indexOf(queryNorm) >= 0; })
        .sort(function (a, b) {
          var difference = suggestionScore(a, queryNorm) - suggestionScore(b, queryNorm);
          return difference || a.name.localeCompare(b.name);
        })
        .slice(0, 6);

      if (!currentMatches.length) {
        if (noResults) noResults.hidden = false;
      } else {
        currentMatches.forEach(function (guide, indexNumber) {
          results.appendChild(makeSuggestion(guide, query, indexNumber));
        });
      }

      if (freehandLabel) freehandLabel.textContent = 'Add "' + query + '" as typed';
      openPopup();
    }

    function exactInputItem() {
      var value = input.value.trim();
      var guide = exactGuide(maps, value, '', '');
      return guide ? guideItem(guide) : typedItem(value);
    }

    function compileBody() {
      if (!selected) return;
      var lines = [
        'Dream board event',
        'Schema: 2',
        'Action: ' + currentAction,
        'Request key: ' + selected.key,
        'Request name: ' + selected.name
      ];
      if (selected.guide) lines.push('Guide handle: ' + selected.guide.id);
      if (selected.sci) lines.push('Scientific name: ' + selected.sci);
      if (selected.spice) lines.push('Spice: ' + selected.spice);
      body.value = lines.join('\n');
    }

    function resetConfirmButton() {
      if (!confirmButton) return;
      confirmButton.disabled = false;
      confirmButton.textContent = currentAction === 'vote' ? 'Confirm vote' : 'Confirm request';
    }

    function revealContact(item, requestedAction) {
      selected = item;
      currentAction = requestedAction || (itemsByKey[item.key] ? 'vote' : 'request');
      input.value = item.name;
      compileBody();
      closePopup();
      contact.hidden = false;
      if (contactCopy) {
        contactCopy.textContent = currentAction === 'vote'
          ? 'Confirm where Big Z can reach you. This adds one approved keeper vote for ' + item.name + '.'
          : 'Leave a real name and email so Big Z can follow up if ' + item.name + ' lands.';
      }
      if (confirmButton) confirmButton.textContent = currentAction === 'vote' ? 'Confirm vote' : 'Confirm request';
      setStatus('');
      var target = author && !author.value ? author : (email && !email.value ? email : confirmButton);
      if (target) target.focus({ preventScroll: true });
    }

    function beginFromInput() {
      var value = input.value.trim();
      if (!value) {
        setStatus('Name a fella first.');
        input.focus();
        return;
      }
      if (!selected || normalize(selected.name) !== normalize(value)) selected = exactInputItem();
      var existingItem = itemsByKey[selected.key];
      if (existingItem && existingItem.isComplete) {
        contact.hidden = true;
        setStatus(existingItem.product
          ? 'Good news — this fella is in stock now. Use the shop link in Found / In Stock.'
          : 'Big Z already marked this request complete. It is listed under Found / In Stock.');
        var completedRow = root.querySelector('[data-bz-completed-item][data-item-key="' + selected.key + '"]');
        if (completedRow) completedRow.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'center'
        });
        return;
      }
      if (submitted[selected.key]) {
        setStatus('A vote for this fella was already sent from this browser and may still be awaiting approval.');
        contact.hidden = true;
        return;
      }
      revealContact(selected, existingItem ? 'vote' : 'request');
    }

    input.addEventListener('input', function () {
      selected = null;
      contact.hidden = true;
      setStatus('');
      renderSuggestions();
    });
    input.addEventListener('focus', function () {
      if (input.value.trim()) renderSuggestions();
    });
    input.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        if (popup.hidden) renderSuggestions();
        setActiveOption(activeOption + 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        if (popup.hidden) renderSuggestions();
        setActiveOption(activeOption - 1);
      } else if (event.key === 'Enter' && !popup.hidden && activeOption >= 0) {
        event.preventDefault();
        choose(guideItem(currentMatches[activeOption]));
      } else if (event.key === 'Escape') {
        closePopup();
      }
    });

    if (freehand) {
      freehand.addEventListener('click', function () {
        if (!input.value.trim()) return;
        choose(typedItem(input.value));
      });
    }
    nextButton.addEventListener('click', beginFromInput);
    if (cancelButton) {
      cancelButton.addEventListener('click', function () {
        contact.hidden = true;
        nextButton.focus();
      });
    }

    form.addEventListener('submit', function (event) {
      if (honeypot && honeypot.value.trim()) {
        event.preventDefault();
        return;
      }
      if (!selected || contact.hidden) {
        event.preventDefault();
        beginFromInput();
        return;
      }

      compileBody();
      sessionSet('pending', {
        key: selected.key,
        name: selected.name,
        sci: selected.sci || '',
        spice: selected.spice || 0,
        guideId: selected.guide ? selected.guide.id : '',
        action: currentAction,
        at: Date.now()
      });
      if (confirmButton) {
        confirmButton.disabled = true;
        confirmButton.textContent = 'Sending…';
      }
      setStatus('Sending to Big Z…');
    });

    window.addEventListener('pageshow', function () {
      resetConfirmButton();
      if (status && status.textContent.indexOf('Sending to Big Z') === 0) setStatus('');
    });

    document.addEventListener('click', function (event) {
      if (search && !search.contains(event.target)) closePopup();
    });

    root.addEventListener('click', function (event) {
      var vote = event.target.closest('[data-bz-vote]');
      if (!vote || !root.contains(vote)) return;
      var key = vote.getAttribute('data-item-key');
      var item = itemsByKey[key];
      if (!item) return;
      if (submitted[key]) {
        setStatus('A vote for this fella was already sent from this browser and may still be awaiting approval.');
      } else {
        revealContact(item, 'vote');
        root.querySelector('.bz-wishlist-request').scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      }
    });

    var params = new URLSearchParams(window.location.search);
    var prefill = params.get('wish');
    var guideHandle = params.get('care_guide');
    if (guideHandle && maps.byId[guideHandle]) {
      selected = guideItem(maps.byId[guideHandle]);
      input.value = selected.name;
      setStatus('Spice ' + selected.spice + ' comes from the care-guide index.');
    } else if (prefill) {
      input.value = prefill;
      selected = exactInputItem();
    }

    if (retryDraft && retryDraft.name) {
      var retryGuide = retryDraft.guideId ? maps.byId[retryDraft.guideId] : null;
      var retryItem = retryGuide ? guideItem(retryGuide) : {
        id: '',
        key: retryDraft.key || 'typed:' + normalize(retryDraft.name),
        name: retryDraft.name,
        sci: retryDraft.sci || '',
        spice: safeInteger(retryDraft.spice, 0),
        guide: null
      };
      revealContact(retryItem, retryDraft.action === 'vote' ? 'vote' : 'request');
      setStatus('Fix the highlighted field and try again.');
    }
  }

  function init(root) {
    if (!root || root.getAttribute('data-bz-wishlist-ready') === 'true') return;
    root.setAttribute('data-bz-wishlist-ready', 'true');

    var index = readIndex(root);
    var maps = buildIndexMaps(index);
    var items = aggregateEvents(readEvents(root, maps));
    var stockProducts = null;
    var itemsByKey = {};
    var submitted = storageGet('submitted', {});
    if (!submitted || typeof submitted !== 'object' || Array.isArray(submitted)) submitted = {};
    var pending = sessionGet('pending', null);
    var hasSuccess = !!root.querySelector('[data-bz-wishlist-success]');
    var hasError = !!root.querySelector('[data-bz-wishlist-error]');
    var retryDraft = pending && hasError ? pending : null;
    if (pending && pending.key && hasSuccess) {
      submitted[pending.key] = true;
      storageSet('submitted', submitted);
    }
    if (
      hasSuccess ||
      hasError ||
      (pending && (!pending.at || Date.now() - pending.at > 30 * 60 * 1000))
    ) {
      sessionRemove('pending');
    }

    function renderBoard() {
      var classified = classifyItems(items, stockProducts);
      Object.keys(itemsByKey).forEach(function (key) { delete itemsByKey[key]; });
      items.forEach(function (item) { itemsByKey[item.key] = item; });
      renderTop(root, classified.open, submitted);
      renderCompleted(root, classified.completed);
      renderCommunity(root, classified.open, submitted);

      var stockStatus = root.querySelector('[data-bz-stock-status]');
      if (stockStatus && stockProducts) {
        var liveCount = classified.completed.filter(function (item) { return !!item.product; }).length;
        stockStatus.textContent = liveCount === 1
          ? '1 exact board match is in stock now. Store availability updates this list automatically.'
          : liveCount + ' exact board matches are in stock now. Store availability updates this list automatically.';
      }
    }

    renderBoard();
    setupCollapses(root);
    setupSpectrum(root);
    setupCompletedExpansion(root);
    setupForm(root, index, maps, itemsByKey, submitted, retryDraft);

    loadAllComments(root).then(function (commentRecords) {
      if (!commentRecords) return;
      items = aggregateEvents(readEvents(root, maps, commentRecords));
      renderBoard();
    }).catch(function (error) {
      console.warn('[Dream Board] Could not load the complete comment ledger.', error);
    });

    loadStockProducts(root).then(function (products) {
      stockProducts = products;
      renderBoard();
    }).catch(function (error) {
      var stockStatus = root.querySelector('[data-bz-stock-status]');
      if (stockStatus) {
        stockStatus.textContent = 'Live stock matching is temporarily unavailable. Showing Big Z’s manual completions.';
      }
      console.warn('[Dream Board] Could not load the live stock catalog.', error);
    });
  }

  function initAll(scope) {
    Array.prototype.slice.call((scope || document).querySelectorAll('[data-bz-wishlist]')).forEach(init);
  }

  ready(function () {
    initAll(document);
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  });
})();
